//Serviços
import { Axios } from "../../service/serviceBasic";
import { converterObjActionForObjReduceFileUploadDocumentosAnexos } from "../../helper/converter";

//Tipos
import {
  SET_DOCUMENTOS_ANEXOS,
  LOADING_DOCUMENTOS_ANEXOS,
  LOADING_DOCUMENTOS_ANEXOS_ARRAY,
  ERROR_DOCUMENTOS_ANEXOS,
  ERROR_DOCUMENTOS_ANEXOS_ARRAY,
  HANDLE_CHANGE_DOCUMENTOS_ADMINISTRADOR_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICADEZMAIS_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAMENOSDEZ_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICANACIONAL_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICAESTRANGEIRA_VALUE_FLAG,
  HANDLE_CHANGE_DOCUMENTOS_PROCURADOR_VALUE_FLAG,
  DELETE_DOCUMENTOS_ANEXO,
  DELETE_DOCUMENTOS_ARRAY_ANEXO,
  SET_DOCUMENTOS_ANEXOS_ARRAY,
  DELETE_GROUP_DOC,
  DELETE_GROUP_DOC_ARRAY,
  ADICIONAR_SOCIO_DEZOUMAIS,
  ADICIONAR_SOCIO_MENOSDEZ
} from "./types";
// import { toast } from "react-toastify";

const loadingDocumentosAnexosAction = ({ id, asyncLoading }) => ({
  type: LOADING_DOCUMENTOS_ANEXOS,
  payload: { id, asyncLoading },
});
const loadingDocumentosAnexosArrayAction = ({ id, asyncLoading, nameDocs }) => ({
  type: LOADING_DOCUMENTOS_ANEXOS_ARRAY,
  payload: { id, asyncLoading, nameDocs },
});
const errorDocumentosAnexosAction = ({ id, errorMessage }) => ({
  type: ERROR_DOCUMENTOS_ANEXOS,
  payload: { id, errorMessage },
});

const errorDocumentosAnexosArrayAction = ({ id, errorMessage, nameDocs }) => ({
  type: ERROR_DOCUMENTOS_ANEXOS_ARRAY,
  payload: { id, errorMessage, nameDocs },
});

const setObjDocumentosAnexosAction = (obj) => ({
  type: SET_DOCUMENTOS_ANEXOS,
  payload: obj,
});

const setObjDocumentosAnexosArrayAction = (obj) => ({
  type: SET_DOCUMENTOS_ANEXOS_ARRAY,
  payload: obj,
});

const deleteGroupDoc = (obj) => ({
  type: DELETE_GROUP_DOC,
  payload: obj,
});

const deleteGroupDocArray = (obj) => ({
  type: DELETE_GROUP_DOC_ARRAY,
  payload: obj,
});

export const handleChangeDocumentosAnexosArray = (element) => (
  dispatch,
  getState
) => {
  let { id, base64, nameDocs } = element;

  if (element.errorNotification && element.errorNotification !== "") {
    dispatch(
      errorDocumentosAnexosAction({
        id,
        errorMessage: element.errorNotification,
      })
    );
    return;
  }

  if (!base64) {
    dispatch(deleteGroupDocArray(element));
    return;
  } 

  if (element.fileType === "jpeg") {
    element.fileType = 1;
  } else if (element.fileType === "png") {
    element.fileType = 2;
  } else {
    element.fileType = 3;
  } 

  let objResult = converterObjActionForObjReduceFileUploadDocumentosAnexos(
    element
  );
  dispatch(loadingDocumentosAnexosArrayAction({ id, asyncLoading: true, nameDocs }));

  return Axios.post("/v1/cliente/documentoarquivo/upload", objResult)
    .then(({ data }) => {
      element.IdDocumentoArquivo = data.IdDocumentoArquivo;

      element.base64 = 'uploaded';

      dispatch(setObjDocumentosAnexosArrayAction(element));
    })
    .catch((error) => {
      dispatch(
        errorDocumentosAnexosArrayAction({
          id,
          errorMessage: "Seu documento não foi enviado. Tente novamente.",
          nameDocs
        })
      );
    })
    .finally(() => {
      dispatch(loadingDocumentosAnexosArrayAction({ id, asyncLoading: false, nameDocs }));
    });
}

export const handleChangeDocumentosAnexos = (element) => (
  dispatch,
  getState
) => {
  let { id, base64 } = element;

  if (element.errorNotification && element.errorNotification !== "") {
    dispatch(
      errorDocumentosAnexosAction({
        id,
        errorMessage: element.errorNotification,
      })
    );
    return;
  }

  if (!base64) {
    dispatch(deleteGroupDoc(element));
    return;
  }  

  if (element.fileType === "jpeg") {
    element.fileType = 1;
  } else if (element.fileType === "png") {
    element.fileType = 2;
  } else {
    element.fileType = 3;
  }

  let objResult = converterObjActionForObjReduceFileUploadDocumentosAnexos(
    element
  );
  dispatch(loadingDocumentosAnexosAction({ id, asyncLoading: true }));

  return Axios.post("/v1/cliente/documentoarquivo/upload", objResult)
    .then(({ data }) => {
      element.IdDocumentoArquivo = data.IdDocumentoArquivo;
      
      element.base64 = 'uploaded';

      dispatch(setObjDocumentosAnexosAction(element));
    })
    .catch((error) => {
      dispatch(
        errorDocumentosAnexosAction({
          id,
          errorMessage: "Seu documento não foi enviado. Tente novamente.",
        })
      );
    })
    .finally(() => {
      dispatch(loadingDocumentosAnexosAction({ id, asyncLoading: false }));
    });
};

export const handleChangeDocumentosAdministradorValueFlag = (event) => (
  dispatch,
  getState
) => {
  dispatch({
    type: HANDLE_CHANGE_DOCUMENTOS_ADMINISTRADOR_VALUE_FLAG,
    payload: event.value,
  });
};

export const handleChangeDocumentosSocioPessoaFisicaDezMaisValueFlag = (
  event
) => (dispatch, getState) => {
  dispatch({
    type: HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICADEZMAIS_VALUE_FLAG,
    payload: event,
  });
};

export const handleChangeDocumentosSocioPessoaFisicaMenosDezValueFlag = (
  event
) => (dispatch, getState) => {
  dispatch({
    type: HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAFISICAMENOSDEZ_VALUE_FLAG,
    payload: event,
  });
};

export const handleChangeDocumentosSocioPessoaJuridicaNacionalValueFlag = (
  event
) => (dispatch, getState) => {
  dispatch({
    type: HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICANACIONAL_VALUE_FLAG,
    payload: event.value,
  });
};

export const handleChangeDocumentosSocioPessoaJuridicaEstrangeiraValueFlag = (
  event
) => (dispatch, getState) => {
  dispatch({
    type: HANDLE_CHANGE_DOCUMENTOS_SOCIOPESSOAJURIDICAESTRANGEIRA_VALUE_FLAG,
    payload: event.value,
  });
};

export const handleChangeDocumentosProcuradorValueFlag = (event) => (
  dispatch,
  getState
) => {
  dispatch({
    type: HANDLE_CHANGE_DOCUMENTOS_PROCURADOR_VALUE_FLAG,
    payload: event.value,
  });
};

export const documentosDeleteFile = (element) => (dispatch, getState) => {
  const { documentosAnexosReducer } = getState();
  let document = { ...documentosAnexosReducer[element.id] };

  let documents = document.documents.filter((documento) => {
    return documento.IdDocumentoArquivo !== element.IdDocumentoArquivo;
  });

  document.documents = [...documents];

  dispatch({
    type: DELETE_DOCUMENTOS_ANEXO,
    payload: document,
  });
};

export const documentosArrayDeleteFile = (element) => (dispatch, getState) => {

  dispatch({
    type: DELETE_DOCUMENTOS_ARRAY_ANEXO,
    payload: element,
  });
};

export const adicionarSocioDezOuMais = () => (dispatch) => {
  dispatch({
    type: ADICIONAR_SOCIO_DEZOUMAIS
  });
};

export const adicionarSocioMenosDez = () => (dispatch) => {
  dispatch({
    type: ADICIONAR_SOCIO_MENOSDEZ
  });
};
